import type { PropsWithChildren } from 'react';

import { Icon, Typography } from '@polyseme/design-system';
import { cn } from '@polyseme/utils/cn/cn-utils';

export const Helper = ({
  children,
  className,
}: PropsWithChildren & {
  className?: string;
}) => (
  <div
    className={cn('flex items-start gap-2 text-muted-foreground', className)}
  >
    <Icon className="text-muted-foreground" name="info" />
    <Typography
      className="whitespace-pre-wrap text-muted-foreground"
      variant="caption"
    >
      {children}
    </Typography>
  </div>
);
